import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthPageManageService {

  private currPage: BehaviorSubject<string> = new BehaviorSubject("");
  private smsKey: BehaviorSubject<any> = new BehaviorSubject("");

  constructor(
    private router: Router
  ) { }

  getCurrPage(): Observable<string> {
    return this.currPage.asObservable();
  }

  setCurrPage(currPage: string): void {
  
    this.currPage.next(currPage);
  }

  // Move component

  moveToLogin() {
  
    this.setCurrPage("login");
  }

  moveToRegister() {
    this.setCurrPage("register");
  }

  moveToForgotPass() {
    this.setCurrPage("forgotpass");
  }

  // Redirect

  goRegister(redirectPage: string) {
    this.setCurrPage("register")
    this.router.navigate(["/auth" + "/" + redirectPage]);
  }

  goLogin(redirectPage: string) {
 
  
    this.setCurrPage("login");
       this.router.navigate(["/auth" + "/" + redirectPage]);
  }


  // Sms key

  getSmsKey(): Observable<any> {
    return this.smsKey.asObservable();
  }

  setSmsNotif(smsKey: any): void {
    this.smsKey.next(smsKey);
  }

  removeSmskey(): void {
    this.smsKey.next(null);
  }

}
